import React, { useEffect, useState } from "react";
import { Modal, Box, Typography, Button, TextField } from "@mui/material";
import OtpInput from "react-otp-input";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};

function OtpModal({ open, onClose, otp, onVerify }) {
  const [enteredOtp, setEnteredOtp] = useState("");

  const handleVerify = () => {
    onVerify(enteredOtp);
  };

  useEffect(() => {
    setEnteredOtp("");
  }, [onVerify, open, onClose]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h6" mb={2}>
          Enter OTP
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={2}>
          (Testing: OTP is <strong>{otp}</strong>)
        </Typography>

        <OtpInput
          value={enteredOtp}
          onChange={setEnteredOtp}
          numInputs={4}
          shouldAutoFocus
          renderInput={(props) => <input {...props} />}
          inputStyle={{
            width: "3rem",
            height: "3rem",
            margin: "0 0.5rem",
            fontSize: "1.5rem",
            borderRadius: 4,
            border: "1px solid #ccc",
          }}
        />

        <Box mt={4} display="flex" justifyContent="center" gap={2}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleVerify}>
            Verify
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default OtpModal;
